<template>
  <DashboardWidgetGauge class="widget-ros" :loading="loading" title="ROS | Return on Sales" :min="min" :max="max" :value="value" />
</template>

<script>

export default {
  name: 'dashboard-widget-ros',
  components: {
    DashboardWidgetGauge: () => import('../BaseWidgets/DashboardWidgetGauge'),
  },
  props: {
    min: {
      type: Number,
      default: 5,
    },
    max: {
      type: Number,
      default: 8,
    },
    value: {
      type: Number,
    },
  },
  data () {
    return {
      loading: false,
    };
  },
};

</script>
